import React from "react";
import { Container } from "components/common";
import { Wrapper, Details } from "./styles";
export const Experience = () => {
     return (
    <div>
      <Wrapper as={Container} id='experience'>
        <h1><u>Experience:</u></h1>
        <Details as={Container} id='exp_bos'>
          <div className='containers'>
              <div className='skill_box'>
              <div className='skill_title'>
                
                <h2>INTERNSHIP:<i>(cyber security)</i><br></br><br></br>
                <h3><u>VIRTUALLY TESTING FOUNDATION</u><br></br>During this internship program,I will learned Kubernetes, hands-on VMware virtualization and
network security. </h3></h2>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            <hr></hr>
             <div className='skill_box'>
              <div className='skill_title'>
                
                <h2>EXTERNSHIP:<i>(Web Developement)</i><br></br><br></br>
                <h3><u>CRIO.DO</u><br></br>STAGE1: During these stage, I will learned HTTPS, REST API'S , GIT AND  GITHUB, AWS SERVISES and hand on project Qprofile .</h3></h2>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
          </div>
        </Details>
      </Wrapper>
    </div>
  );
};